<template>
  <div>
    <div class="menu">
      <Item
        v-for="(item, index) in menu"
        :key="item.data.id"
        :ln="ln"
        :item="item"
        :responsive="responsive"
        :isActive="isActive(item.data.id)"
        :activeTabletMenu="activeTabletMenu"
        :activeTabletMenuAcc="activeTabletMenuAcc"
        :class="isActive(item.data.id) && 'active'" />
    </div>
    <p class="info">* {{locale.preview_msg_noicon}}</p>
  </div>
</template>

<script>
import Item from '@/components/Menu/RenderItem'

export default {
  name: 'Render',
  props: [
    'responsive',
    'activeTabletMenu',
    'activeTabletMenuAcc'
  ],
  components: {
    Item
  },
  computed: {
    locale () {
      return this.$store.state.service.locale.data
    },
    ln () {
      return this.$store.state.setting.lang.current
    },
    mainId () {
      return this.$store.state.setting.main.menu
    }
  },
  data () {
    return {
      menu: [],
      sns: []
    }
  },
  created () {
    this.$store.dispatch('menu/getMenuItem', this.mainId).then((res) => {
      this.menu = !res ? [] : res.tree
      this.sns = !res ? [] : res.snsList.filter(x => x.active)
    })
  },
  methods: {
    isActive (id) {
      const responsive = this.responsive
      const disabledByMode = (word) => `disabled${word.charAt(0).toUpperCase()}${word.slice(1)}`
      const enabledMenu = (data) => !data[disabledByMode(responsive)]
      const activeMenu = this.menu.filter(x => enabledMenu(x.data))
      const isActive = activeMenu.find(x => x.children)
      return isActive ? isActive.data.id === id : activeMenu[0] ? activeMenu[0].data.id === id : false
    }
  }
}
</script>
